var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useRef, useState, } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSafeFormData, } from '../types/index';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { useHandleEventUpdate } from '../hooks/useHandleEventUpdate';
import { useEventComposerGlobalContext } from './EventComposerGlobalContext';
import { useEventApi } from '../hooks/useEvent/useEventApi';
import { useConfig } from '../context/ConfigContext';
import { useSpacePrivacySettings } from '../hooks/useSpacePrivacySettings';
import { getRemovedSpaceInvitees, } from '../utils/spaceRemovalDiff';
/* Stable no-op so the decline api instance never double-reports errors. */
var silentOnError = function () { };
var EditEventContext = createContext({
    initialEvent: undefined,
    eventPermissions: undefined,
    handleEventUpdate: function () { },
    declineRemovedSpaces: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, true];
    }); }); },
    recurringEventToUpdate: null,
    setRecurringEventToUpdate: function () { },
    editEventError: null,
    updatingEvent: false,
    setEditEventError: function () { },
    shouldShowPrivacyIndicator: false,
    spaceReservationVisibilityEnabled: false,
});
export var EditEventContextProvider = function (_a) {
    var _b;
    var children = _a.children, onClose = _a.onClose, onSubmit = _a.onSubmit, onEventChange = _a.onEventChange, initialEvent = _a.initialEvent, eventPermissions = _a.eventPermissions, fetchingEvent = _a.fetchingEvent;
    var _c = useConfig(), tenantId = _c.tenantId, environmentUrls = _c.environmentUrls, userContext = _c.userContext, accessToken = _c.accessToken;
    var _d = useEventComposerGlobalContext(), timezone = _d.timezone, onError = _d.onError, onTrackComposerEvent = _d.onTrackComposerEvent;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _e = useFormContext(), subscribe = _e.subscribe, getValues = _e.getValues, setValue = _e.setValue;
    var formData = useSafeFormData();
    var t = useTranslation('meetingRooms').t;
    var _f = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), updateEvent = _f.updateEvent, editEventError = _f.eventError, setEditEventError = _f.setEventError, updatingEvent = _f.composingEvent;
    // Separate api instance for declines with a silent onError — failures are
    // reported once, with the specific message built in declineRemovedSpaces.
    var removeSpaceInvitee = useEventApi({
        onError: silentOnError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).removeSpaceInvitee;
    // Invitee ids we already declined. `initialEvent` is a snapshot from when
    // edit opened, so if declines succeed but the PATCH fails, a retry would
    // re-diff and decline the same invitees again without this. A ref rather
    // than state: nothing renders from it, and the async flow must read its
    // own writes.
    var declinedInviteeIdsRef = useRef(new Set());
    // True while declines are in flight. Folded into `updatingEvent` so the
    // Update button shows loading and blocks double-clicks during this phase.
    var _g = __read(useState(false), 2), decliningSpaces = _g[0], setDecliningSpaces = _g[1];
    var declineRemovedSpaces = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var eventId, removed, results, failed, results_1, results_1_1, _a, space, declined, failedIds_1, initialSpaces, restoredSpaces_1;
        var e_1, _b;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    eventId = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.id;
                    if (!eventId)
                        return [2 /*return*/, true];
                    removed = getRemovedSpaceInvitees(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaces, getValues('spaces')).filter(function (space) { return !declinedInviteeIdsRef.current.has(space.inviteeId); });
                    if (!removed.length)
                        return [2 /*return*/, true];
                    setDecliningSpaces(true);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.all(removed.map(function (space) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = {
                                            space: space
                                        };
                                        return [4 /*yield*/, removeSpaceInvitee(eventId, space.inviteeId)];
                                    case 1: return [2 /*return*/, (_a.declined = _b.sent(),
                                            _a)];
                                }
                            });
                        }); }))];
                case 2:
                    results = _e.sent();
                    failed = [];
                    try {
                        for (results_1 = __values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                            _a = results_1_1.value, space = _a.space, declined = _a.declined;
                            if (declined) {
                                declinedInviteeIdsRef.current.add(space.inviteeId);
                            }
                            else {
                                failed.push(space);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (results_1_1 && !results_1_1.done && (_b = results_1.return)) _b.call(results_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    if (!failed.length)
                        return [2 /*return*/, true];
                    failedIds_1 = new Set(failed.map(function (space) { return space.id; }));
                    initialSpaces = (_c = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaces) !== null && _c !== void 0 ? _c : [];
                    restoredSpaces_1 = __spreadArray([], __read(((_d = getValues('spaces')) !== null && _d !== void 0 ? _d : [])), false);
                    initialSpaces.forEach(function (space, index) {
                        if (failedIds_1.has(space.id)) {
                            restoredSpaces_1.splice(Math.min(index, restoredSpaces_1.length), 0, space);
                        }
                    });
                    setValue('spaces', restoredSpaces_1, { shouldDirty: true });
                    onError(new Error(t('errors.failed_to_remove_spaces_on_update', {
                        names: failed.map(function (space) { return space.name; }).join(', '),
                    })));
                    return [2 /*return*/, false];
                case 3:
                    setDecliningSpaces(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [initialEvent, getValues, setValue, removeSpaceInvitee, onError, t]);
    var _h = useCalendarIntegrationsContext(), calendarType = _h.calendarType, calendarMailboxAddress = _h.calendarMailboxAddress;
    var _j = __read(useState(null), 2), recurringEventToUpdate = _j[0], setRecurringEventToUpdate = _j[1];
    var _k = useSpacePrivacySettings((_b = formData.spaces) !== null && _b !== void 0 ? _b : []), spaceReservationVisibilityEnabled = _k.spaceReservationVisibilityEnabled, shouldShowPrivacyIndicator = _k.shouldShowPrivacyIndicator;
    var handleEventUpdate = useHandleEventUpdate({
        formData: formData,
        timezone: timezone,
        initialEvent: initialEvent,
        calendarType: calendarType,
        calendarMailboxAddress: calendarMailboxAddress,
        updateEvent: updateEvent,
        declineRemovedSpaces: declineRemovedSpaces,
        setRecurringEventToUpdate: setRecurringEventToUpdate,
        onError: onError,
        onClose: onClose,
        onSubmit: onSubmit,
        onTrackComposerEvent: onTrackComposerEvent,
    }).handleEventUpdate;
    useEffect(function () {
        if (fetchingEvent)
            return;
        if (!onEventChange)
            return;
        var callback = subscribe({
            formState: {
                values: true,
            },
            callback: function (_a) {
                var values = _a.values;
                onEventChange(values);
            },
        });
        return function () { return callback(); };
    }, [subscribe, onEventChange, fetchingEvent]);
    return (_jsx(EditEventContext.Provider, { value: {
            initialEvent: initialEvent,
            eventPermissions: eventPermissions,
            handleEventUpdate: handleEventUpdate,
            declineRemovedSpaces: declineRemovedSpaces,
            recurringEventToUpdate: recurringEventToUpdate,
            setRecurringEventToUpdate: setRecurringEventToUpdate,
            editEventError: editEventError,
            updatingEvent: updatingEvent || decliningSpaces,
            setEditEventError: setEditEventError,
            shouldShowPrivacyIndicator: shouldShowPrivacyIndicator,
            spaceReservationVisibilityEnabled: spaceReservationVisibilityEnabled,
        }, children: children }));
};
export var useEditEventContext = function () {
    return useContext(EditEventContext);
};
